

module.exports.logger = console
module.exports.errorLogger = (req, res, next, err) => {
  console.error(err)
  next()
}